import { render, staticRenderFns } from "./repair-add-detail.vue?vue&type=template&id=2dd5720a&scoped=true&"
import script from "./repair-add-detail.vue?vue&type=script&lang=js&"
export * from "./repair-add-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5720a",
  null
  
)

export default component.exports